"use client";

import {navElementClasses, navElementWrapperClasses} from "./navElementClasses";
import {Link, LinkProps} from "react-aria-components";
import clsMerge from "@/app/util/clsMerge";
import RACRouterProvider from "../contexts/RACRouterProvider";
import {useButtonInputTracking} from "../useButtonInputTracking";

/**
 * Overwrite className and children from LinkProps because RAC has some neat
 * stuff built in that we aren't using for this component
 */
type NavElementProps = Omit<LinkProps, "className" | "children"> & {
	className?: string;
	children: React.ReactNode;
	href: string;
	isExternal?: true;
};

const NavElement: React.FC<NavElementProps> = ({
	children,
	className,
	href = "/",
	isExternal,
	onPress,
	...props
}) => {
	const {trackedOnPress} = useButtonInputTracking({
		onPress,
		props: {href, isExternal, ...props},
	});
	const linkElement = (
		<div role="menuitem">
			<Link
				className={clsMerge(navElementWrapperClasses, "group block", className)}
				href={href}
				onPress={trackedOnPress}
				{...props}
			>
				<div className={clsMerge(navElementClasses, "inline-block")}>
					{children}
				</div>
			</Link>
		</div>
	);

	if (isExternal) {
		return linkElement;
	}

	return <RACRouterProvider>{linkElement}</RACRouterProvider>;
};

export default NavElement;
